import { getUsersMeOrganisationsCurrentDimensionsSelector } from "./getUsersMeOrganisationsCurrentDimensionsSelector";
import { RootState } from "../../../store";

export const dimensionsLoadingSelector = (state: RootState) => {
  return getUsersMeOrganisationsCurrentDimensionsSelector(state)?.isLoading;
};
